// extracted by mini-css-extract-plugin
export default {"overlay":"chart-loading-overlay_overlay__en2YV"};